import "devextreme/dist/css/dx.common.css";
// import "devextreme/dist/css/dx.material.blue.light.css";
// import "./themes/generated/theme.base.css";
import "../src/themes/generated/custom-themes.css";
import "../src/themes/variables.scss";
import "@mdi/font/css/materialdesignicons.css";
import "../src/assets/style/style.css";
import "../src/assets/style/custom.css";
import "../src/assets/style/base.scss";